import React, { useEffect, useState } from 'react'
import Api from 'app/services/api/entities/api'

import config from 'config'
import { IonIcon, Button } from 'controls'

import { version as versionStyles } from './styles'

const BUILD_VERSION = config('VERSION')
const TITLE = 'Asegurate de tener siempre la versión más reciente'
const TICK = 1000 * 60 * 5 // 5 minutes

const GoodVersion = ({ version }) => (
  <p
    title={TITLE}
  >
    <IonIcon
      icon="ios-checkmark"
      style={{
        fontSize: '1rem',
        padding: '0 .3rem',
      }}
    />
    VERSIÓN: v
    {version}
    <style jsx>{versionStyles}</style>
  </p>
)

const BadVersion = ({ version }) => (
  <p
    title={TITLE}
  >
    <IonIcon
      icon="ios-close"
      style={{
        fontSize: '1rem',
        padding: '0 .3rem',
      }}
    />
    <b>
      VERSIÓN: v
      {version}
    </b>
    <p>
      Click
      {' '}
      <Button outline color="none" onClick={() => { window.location = window.location }}><b>AQUÍ</b></Button>
      {' '}
      para actualizar
    </p>
    <style jsx>{versionStyles}</style>
  </p>
)

const checkVersion = (callback) => async () => {
  try {
    const response = await Api.getVersion()
    if (response.status === 200) {
      callback(response.data.version)
    }
  } catch (error) {
    callback(String(error))
  }
}

const VersionButton = () => {
  const [deployedVersion, setDeployedVersion] = useState(BUILD_VERSION)
  useEffect(() => {
    checkVersion(setDeployedVersion)()
    const interval = setInterval(checkVersion(setDeployedVersion), TICK)
    return () => clearInterval(interval)
  }, [])

  if (deployedVersion === BUILD_VERSION) {
    return <GoodVersion version={BUILD_VERSION} />
  }

  return <BadVersion version={BUILD_VERSION} />
}

export {
  VersionButton as default
}
